<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='""' class="text-center my-3" >
                <template #default>درخواست خود را ثبت کنید تا کارشناسان ما در اولین فرصت جهت راهنمایی با شما تماس بگیرند.   </template>
                </m-h4><m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":2,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH4,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
